import { History } from "history";
import { Decorator } from "final-form";

export const createSetStepFromUrl = (history: History): Decorator => ({ mutators }) => {
  const { navigationApi } = mutators.getStepManagerApi();
  history.listen((location, action) => {
    if (action === "POP") {
      const newStepId = location.pathname.replace(/\//g, "");
      navigationApi.goTo(newStepId);
    }
  });
  return () => undefined;
};
